/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  Props as SelectProps,
} from 'react-select';
import type {
  CreatableProps,
} from 'react-select/creatable';

export const texts: Partial<SelectProps<any, any, any>> = {
  placeholder: 'Выберите...',
  noOptionsMessage: () => 'Не найдено',
  loadingMessage: () => 'Загрузка...',
};

export const creatableTexts: Partial<CreatableProps<any, any, any>> = {
  ...texts,
  formatCreateLabel: (inputValue) => `Добавить "${inputValue}"`,
};
